module.exports = __webpack_public_path__ + "static/pro-banner9@2x-3c08ab204b887de14145d062e2f33b3f.jpg";